import React, { useEffect, useState } from "react";
import "./TxnLookup.css";
import { payinStatus, getOrganisation, getInvoice } from "../../../config/LiveApi";
import PayInModal from "./PayInModal";
import { useSelector } from "react-redux";
import { FaFilter } from "react-icons/fa";
import "jspdf-autotable";
import { generatePDF } from "./GeneratePDF";
import { toast } from "react-toastify";

function BulkPayinStatus({
  bulkData,
  setBulkData,
  setProgress,
  setShowProgress,
}) {
  const [modalData, setModalData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  let [checkedStatus, setCheckedStatus] = useState(0);
  const [orgName, setOrgName] = useState(false);
  const [orgOptions, setOrgOptions] = useState([]);
  const [selectedOrgName, setSelectedOrgName] = useState("All");

  const role = useSelector(store => store.userReducer.role);
  const token = useSelector(store => store.userReducer.token);

  const viewData = (item) => {
    setModalData(item);
    setOpenModal(true);
  };

  useEffect(() => {
    const fetchOrganisations = async () => {
      try {
        if(role === "admin" || role === "subAdmin") return;
        const response = await getOrganisation(token);
        const orgData = response.data;
        setOrgOptions(orgData);
      } catch (err) {
        console.error("Error fetching organisations:", err.message);
        toast.error("Unable to fetch organisations.");
      }
    };

    fetchOrganisations();
  }, [token]);


  const checkStatus = async (item, i) => {
    const updatedBulkData = [...bulkData];
    updatedBulkData[i].statusLoading = true;
    setBulkData([...updatedBulkData]);

    const detail = {
      orderId: item.orderId,
      transactionId: item.transactionId,
    };

    try {
      const dataItem = await payinStatus(detail);
      updatedBulkData[i].statusResponse = dataItem;
      updatedBulkData[i].statusChecked = true;
    } catch (error) {
      console.error(`Error fetching status for Order ID ${item.orderId}:`, error);
      updatedBulkData[i].statusResponse = { RESPONSE_STATUS: "ERROR" }; // You can set an error status or message
      updatedBulkData[i].statusChecked = true; // Mark as checked even if it failed
    } finally {
      updatedBulkData[i].statusLoading = false;
      setBulkData(updatedBulkData);
    }
  };

  const checkAllStatus = async () => {
    if (bulkData) {
      setShowProgress(true);
      const updatedBulkData = [...bulkData];
      const promises = [];

      for (let i = 0; i < bulkData.length; i += 2) {
        const batch = bulkData.slice(i, i + 2);
        for (const item of batch) {
          promises.push(checkStatus(item, bulkData.indexOf(item)));
        }
        await Promise.all(promises);
        setCheckedStatus((prev) => prev + batch.length);
        setProgress(((checkedStatus + batch.length) / bulkData.length) * 100);
        promises.length = 0; // Clear the promises for the next batch
      }

      setShowProgress(false);
    }
  };

  const filteredItems = bulkData?.filter((item) => {
    const matchesOrgName =
      selectedOrgName === "All" || !selectedOrgName
        ? true
        : item.orgName === selectedOrgName;

    return matchesOrgName;
  }) ?? [];

  const handleGeneratePDF = (item) => {
    generatePDF(item, token);
  };

  return (
    <div>
      <div>
        <div className="table-main-report-2">
          <table className="table-user-management">
            <thead className="table-user-report-1">
              <tr>
                {(role == "super" || role == "operation" || role=="pros" || role=="subSuper") && (
                  <td className="filter-pos">
                    <div className="data-icon">
                      <p className="user-table-head-report">Org Name</p>
                      <FaFilter
                        style={{
                          marginRight: "0.2rem",
                          width: "1rem",
                          height: "1rem",
                          cursor: "pointer",
                        }}
                        onMouseEnter={() => setOrgName(true)}
                        onMouseLeave={() => setOrgName(false)}
                      />
                    </div>
                    {orgName && (
                      <div
                        className="transfer-mode"
                        onMouseEnter={() => setOrgName(true)}
                        onMouseLeave={() => setOrgName(false)}
                      >
                        <p
                          onClick={() => {
                            setSelectedOrgName("All");
                            setOrgName(false);
                          }}
                        >
                          All
                        </p>
                        {orgOptions.map((org) => (
                          <p
                            key={org.id}
                            onClick={() => {
                              setSelectedOrgName(org.orgName);
                              setOrgName(false);
                            }}
                          >
                            {org.orgName}
                          </p>
                        ))}

                      </div>
                    )}
                  </td>
                )}
                {
                  (role == "super" || role == "operation" || role=="pros" || role=="subSuper") && (
                    <td><p className="user-table-head-report">PG Name</p></td>
                  )
                }
                <td><p className="user-table-head-report">Order Id</p></td>
                <td><p className="user-table-head-report">Transaction Mode</p></td>
                <td><p className="user-table-head-report">Type</p></td>
                <td><p className="user-table-head-report">Amount(₹)</p></td>
                <td><p className="user-table-head-report">Comm(₹)</p></td>
                <td><p className="user-table-head-report">Rolling Reserve(₹)</p></td>
                <td><p className="user-table-head-report">Status</p></td>
                 <td><p className="user-table-head-report">Transaction Date</p></td>
                 <td><p className="user-table-head-report">Updated Date</p></td>
                <td><p className="user-table-head-report">View</p></td>
                { role=='pros' &&(
                  <td>
                  <p className="user-table-head-report">
                  Invoice
                  </p>
                </td>
                )}
                <td>
                  <p className="user-table-head-report">
                    <button className="search-btn" onClick={checkAllStatus}>
                      Check All
                    </button>
                  </p>
                </td>
              </tr>
            </thead>

            <tbody>
              {filteredItems.map((item, i) => {
                item.requestData = JSON.parse(item?.request);
                item.responseData = JSON.parse(item?.resposne);
                const formattedDate = new Date(item.createdAt).toLocaleString();

                return (
                  <tr className="user-table-head-report" key={i}>
                    {(role == "super" || role == "operation" || role=="pros" || role=="subSuper") && (
                      <td><p className="table-user-data-report order-break">{item.responseData?.orgName || item.orgName || "N/A"}</p></td>
                    )}
                    {(role == "super" || role == "operation" || role=="pros" || role=="subSuper") && (
                      <td><p className="table-user-data-report order-break">{item.responseData?.pg || item.pg || "N/A"}</p></td>
                    )}
                    <td><p className="table-user-data-report order-break" style={{width:'150px'}}>{item.responseData?.ORDER_ID || item.orderId|| ""}</p></td>
                    <td><p className="table-user-data-report order-break">{item.requestData?.transactionMode || ""}</p></td>
                    <td><p className="table-user-data-report type-data">{item.type || ""}</p></td>
                    <td><p className="table-user-data-report">{item.RESPONSE_STATUS === "INVALID" ? "INVALID" : item.requestData?.amount}</p></td>
                    <td><p className="table-user-data-report">                            {item.responseStatus === "SUCCESS"
                      ? item.totalComission
                      : 0}</p></td>
                    <td><p className="table-user-data-report">{item.responseStatus === "SUCCESS"
                      ? item.rollingReserve
                      : 0}</p></td>
                    <td>
                      <p
                        className={
                          item && item.statusChecked == true
                            ? item &&
                              item.responseStatus &&
                              item.responseStatus ==
                              "PROCESSING"
                              ? "table-user-data-report process-color yel"
                              : item &&
                                item.responseStatus &&
                                item.responseStatus ==
                                "FAILED"
                                ? "table-user-data-report failed-color red"
                                : item &&
                                  item.responseStatus &&
                                  item.responseStatus == "SUCCESS"
                                  ? "success-color table-user-data-report green"
                                  : "table-user-data-report"
                            : "table-user-data-report"
                        }
                      >
                        {item.responseStatus}
                      </p>
                    </td>

                    <td><p className="table-user-data-report status-table">{formattedDate}</p></td>
                     <td><p className="table-user-data-report status-table">
                        {(() => {
                            const date = new Date(item.updatedAt);
                            const formattedDate = `${date.getDate()}-${
                              date.getMonth() + 1
                            }-${date.getFullYear()}`;
                            const formattedTime = `${date
                              .getHours()
                              .toString()
                              .padStart(2, "0")}:${date
                              .getMinutes()
                              .toString()
                              .padStart(2, "0")}:${date
                              .getSeconds()
                              .toString()
                              .padStart(2, "0")}`;
                            return `${formattedDate} ${formattedTime}`;
                          })()}</p></td>
                    <td>
                      <button className="view-btn-1" onClick={() => viewData(item)}>View</button>
                    </td>
                    {(role === "pros") && (
                        <td>
                          <button
                            className="generate-btn"
                            onClick={() => handleGeneratePDF(item)}
                          >
                            Generate
                          </button>
                        </td>
                      )}
                    <td>
                      <button className="view-btn-1" onClick={() => checkStatus(item, i)}>Check Status</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {openModal && modalData && (
          <PayInModal modalData={modalData} setOpenModal={setOpenModal} />
        )}
      </div>
    </div>
  );
}

export default BulkPayinStatus;
